import React, { useState } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import ImageUploader from 'react-images-upload';
import StarRatings from 'react-star-ratings';
import { useParams,useHistory,useLocation } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import {addReview} from "../Services/reviews.service"
import {fbStorage} from '../Services/firebase'
const Ratee=(props)=> {
  const [myRating,setmyRating] = useState();
  const [reviewTitle,setreviewTitle] = useState();
  const [discripton,setdiscripton] = useState();
  const [userPicture,setuserPicture] = useState();
  const [businessId,setbusinessId] = useState();
  const {id} = useParams();
  const reviewCustom = useLocation();
  const history = useHistory();
  // console.log(id);
  // console.log(reviewCustom.pathname.includes('company'));
  // console.log(reviewCustom.pathname.split('/')[2]);
  const changeRevieTitle=(e)=>{
    if( typeof myRating === 'undefined' )
    {
      //  console.log(myRating);
       toast.error('Please give the rating first');
    }
    else{
      console.log('I am working');
      setreviewTitle(e.target.value);
    }
  }
  const assignRating=(number)=>{
    setmyRating(number);
  }
  const changeDiscription = (e)=>{
  if( typeof reviewTitle === 'undefined' )
  {
    //  console.log(reviewTitle);
     toast.error('Please give the title first');
  }
  else{
    setdiscripton(e.target.value);
  }
  }
  const onDrop=(picture)=>{
    setuserPicture(picture[0]);
    console.log(picture[0]);
  }
  const validatReview = (data)=>{
   let validateSTatus = {
     status:false,
     Message:'Accept Image all items must be provided to submit the review'
   }
   if(typeof data.myRating === "undefined")
   {
    validateSTatus.status=true;
    validateSTatus.Message='Rating is not provied';//"Rating is not provied"
  }
  if(typeof data.reviewTitle === "undefined")
  {
   validateSTatus.status=true;
   validateSTatus.Message='Title is not provided';//"Title is not provided"
  }
  if(typeof data.discripton === "undefined")
  {
   validateSTatus.status=true;
   validateSTatus.Message='Discription is not provied';//"Discription is not provied"
  }
  

   return validateSTatus;
  }
  const SendDataTofirebase =  ()=>{
    let itemId = id;
    const businesData ={myRating,reviewTitle,discripton,userPicture};
    const validate = validatReview(businesData);
    console.log(validate)
     if(validate.status)
     {
       toast.error(validate.Message);
     }
     else{
      let storeUrl = `businessImages/${userPicture.name}`;
      const uploadTask = fbStorage.ref(`businessImages/${userPicture.name}`).put(userPicture);
       uploadTask.on(
       "state_changed",
       snapshot=>{},
       error=>{
         console.log(error);
       },
       ()=>{
         fbStorage.ref("businessImages").child(userPicture.name).getDownloadURL().then((url)=>{
           //adding the check when cmming from the company or not
          if(reviewCustom.pathname.includes('company'))
          {
            let itemId = reviewCustom.pathname.split('/')[2];
            let status = false;
            const businesData ={myRating,reviewTitle,discripton,businessId,itemId,url,status};
            addReview(businesData).then((res)=>{console.log('Response after saving data ',res)});
            history.push('/');  
          }
          else{
            let status = false;
              const businesData ={myRating,reviewTitle,discripton,businessId,itemId,url,status};
              addReview(businesData).then((res)=>{console.log('Response after saving data ',res)});
               history.push('/'); 
            }
          
          console.log(url)})
       })
      toast.success(validate.Message);
     }
    //console.log(storeUrl);

    // let storeUrl = `businessImages/${userPicture.name}`;
    // const uploadTask = fbStorage.ref(`businessImages/${userPicture.name}`).put(userPicture);
    //  uploadTask.on(
    //  "state_changed",
    //  snapshot=>{},
    //  error=>{
    //    console.log(error);
    //  },
    //  ()=>{
    //    fbStorage.ref("businessImages").child(userPicture.name).getDownloadURL().then((url)=>{
    //      //adding the check when cmming from the company or not
    //     if(reviewCustom.pathname.includes('company'))
    //     {
    //       let itemId = reviewCustom.pathname.split('/')[2];
    //       const businesData ={myRating,reviewTitle,discripton,businessId,itemId,url};
    //       addReview(businesData).then((res)=>{console.log('Response after saving data ',res)});
    //       history.push('/');  
    //     }
    //     else{
    //         const businesData ={myRating,reviewTitle,discripton,businessId,itemId,url};
    //         addReview(businesData).then((res)=>{console.log('Response after saving data ',res)});
    //          history.push('/'); 
    //       }
        
    //     console.log(url)})
    //  })

  }
  return (
    <div className="container margin-top-100 mb-5" >

    <div className="signInDiv ">
      <Form className="result-container rating-container">
        <h3 className='bold-semifont blackColor mt-2 text-center'>
        {/* {this.state.companyName} */}
          Comapany Name
        </h3>
        <Form.Group controlId="formRateNumber">
          <Form.Label className='light-font para mt-2 bold-semifont '>Click and rate your experience*</Form.Label>
          <Form.Group controlId="formRating" className="text-center">
            <StarRatings
              rating={myRating}
              // {this.state.rating}
              starRatedColor="orange"
              starEmptyColor="grey"
              starHoverColor='orange'
              changeRating={assignRating}
              //{this.changeRating}
              numberOfStars={5}
              isSelectable='true'
            />

          </Form.Group>
        </Form.Group>
        <Form.Group controlId="formRateTitle">
          <Form.Label className='light-font para mt-2 bold-semifont '>Review Title*</Form.Label>
          <Form.Control as="textarea" name="title" onChange={changeRevieTitle} rows="1" placeholder="Example: what a nice surprise!" value={reviewTitle} />
        </Form.Group>
        <Form.Group controlId="formRateDescription">
          <Form.Label className='light-font para mt-2 bold-semifont '>Describe your experience*</Form.Label>
          <Form.Control as="textarea" name="description" onChange={changeDiscription} rows="4" placeholder="Give accurate information, state the facts and use neutral language." value={discripton} />
        </Form.Group>
        <Form.Group controlId="formImages">
          <Form.Label className='light-font para mt-2 bold-semifont'>Would you like to add photos?</Form.Label>
          <ImageUploader
            withIcon={false}
            buttonText='Upload photo'
            onChange={onDrop}
            imgExtension={['.jpg', '.gif', '.png']}
            maxFileSize={5242880}
            withPreview={true}
            buttonClassName="round-button width-200"
            singleImage={true}
          />
        </Form.Group>
        <div className="form-group text-center">
          <Button className='round-button bgPrimary myRiviewButton' onClick={SendDataTofirebase}>
            Submit your review
          </Button>
          <Toaster />
        </div>
      </Form>
          <Toaster></Toaster>
    </div>


  </div>
  )
}

export default Ratee